import { createContext, useContext, type ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useVariantConfig, type VariantConfig } from '../hooks/useVariantConfig';

interface VariantContextValue {
  variant: string | null;
  variantConfig: VariantConfig | null;
  isLoading: boolean;
}

const VariantContext = createContext<VariantContextValue>({
  variant: null,
  variantConfig: null,
  isLoading: false,
});

export const VariantProvider = ({ children }: { children: ReactNode }) => {
  const [searchParams] = useSearchParams();
  const variant = searchParams.get('variant');
  const { variantConfig, isLoading } = useVariantConfig(variant);

  return <VariantContext.Provider value={{ variant, variantConfig, isLoading }}>{children}</VariantContext.Provider>;
};

export const useVariant = () => useContext(VariantContext);
